"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard,
  FilePlus2,
  ClipboardList,
  Gavel,
  Users,
  User as UserIcon,
  LogOut,
} from "lucide-react";

const BASE_ITEM = { href: "/", label: "Dashboard", icon: LayoutDashboard };

export function Rail() {
  const pathname = usePathname();
  const { me, loggedIn, logout } = useAuth();

  if (!loggedIn) return null;

  const items = [
    BASE_ITEM,
    { href: "/apply", label: "New Application", icon: FilePlus2 },
    { href: "/applications", label: "My Applications", icon: ClipboardList },
    ...(me?.is_committee || me?.is_staff ? [{ href: "/committee", label: "Committee Review", icon: Gavel }] : []),
    ...(me?.is_admin ? [{ href: "/admin/users", label: "User Management", icon: Users }] : []),
  ];

  const displayName = me?.owner?.name ? String(me.owner.name) : me?.username ?? "";
  const roleLabel = me?.is_admin ? "Admin" : me?.is_committee ? me.committee_role ?? "Committee" : me?.is_staff ? "Reviewer" : "Applicant";

  return (
    <nav className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col border-r border-[var(--line)] bg-[var(--surface)]/60 px-3 py-5 md:flex">
      <div className="mb-6 px-2">
        <div className="font-display text-[17px] font-semibold tracking-tight">UAS Registry</div>
      </div>
      <div className="flex flex-col gap-0.5">
        {items.map(({ href, label, icon: Icon }) => {
          const active = pathname === href;
          return (
            <Link
              key={href}
              href={href}
              className="group flex items-center gap-2.5 rounded-sm px-2.5 py-2 text-[13px] transition-colors"
              style={{
                color: active ? "var(--blue)" : "var(--muted)",
                background: active ? "#0b5fa512" : "transparent",
              }}
            >
              <Icon size={15} strokeWidth={2} />
              {label}
            </Link>
          );
        })}
      </div>

      {loggedIn && (
        <div className="mt-auto flex items-center gap-2.5 border-t border-[var(--line)] px-2 pt-4">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#0b5fa5]/10 text-[#0b5fa5]">
            <UserIcon size={14} />
          </div>
          <div className="min-w-0 flex-1 leading-tight">
            <div className="truncate text-[12.5px] font-medium text-[var(--ink)]">{displayName}</div>
            <div className="text-[10px] text-[var(--muted-2)]">{roleLabel}</div>
          </div>
          <button
            onClick={logout}
            title="Sign out"
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-sm text-[var(--muted-2)] transition-colors hover:bg-[var(--surface)] hover:text-[var(--alert)]"
          >
            <LogOut size={14} />
          </button>
        </div>
      )}
    </nav>
  );
}
